import type { OverlapCard } from "../components/OverlapCards";

type OverlapCardRelationship = { value: OverlapCard };

export function getValidOverlapCards(
  cards: readonly OverlapCardRelationship[] | null | undefined
): OverlapCard[] | null {
  if (!cards || cards.length < 2) {
    return null;
  }
  return cards.map((card) => card.value);
}
